import EmailRecipients from './EmailRecipients.component';

export default EmailRecipients;
